import Component from "../../js/lib/component";
import anime from "animejs";
import $ from "jquery";

const classList = {
  root: ".js-products-list",
  body: ".js-products-list-body",
  group: ".js-products-list-group"
};

export default class ProductsList extends Component {
  init() {
    this.Switch = this.childs("Switches")._one();

    if (this.Switch) {
      this.state.currentType = this.Switch.state.currentType;
      this.state.$currentItems = this.filterItems(this.state.currentType);
    }
  }
  events() {
    this.Switch.$.root.on("switches:change", (e, { type }) => {
      this.state.currentType = type;
      this.state.$currentItems = this.filterItems(this.state.currentType);
      this.renderItems();
    });
  }
  renderItems() {
    this.hide().then(() => {
      this.$.body.html(this.state.$currentItems);
      this.show();
    });
  }
  filterItems(type) {
    return type && type !== "all"
      ? this.$.group.filter((i, item) => $(item).data("type") === type)
      : this.$.group;
  }
  hide() {
    return new Promise(resolve => {
      anime({
        targets: this.$.group.get(),
        opacity: 0,
        translateX: 30,
        easing: "easeInCubic",
        duration: 300,
        complete: () => {
          this.$.root.removeClass("is-inited");
          resolve();
        }
      });
    });
  }
  show() {
    const targets = this.state.$currentItems.get();

    anime.set(targets, {
      opacity: 0,
      translateX: -30
    });

    if (this.Switch) {
      this.Switch.toggle();
    }

    this.$.root.addClass("is-inited");

    anime({
      targets,
      opacity: 1,
      translateX: 0,
      easing: "easeOutCubic",
      duration: 300,
      delay: anime.stagger(80)
    });
  }
}
Component.mount(ProductsList, {
  name: "ProductsList",
  classList,
  state: {}
});
